
<!-- Button to Open Popup -->
<div class="col-lg-2">
    <button type="button" class="btn btn-outline-dark" (click)="openPopup()">Add Inventory</button>
  </div>
  
  <!-- Backdrop Overlay for Dim Effect -->
  <div *ngIf="isPopupVisible" class="overlay"></div>
  
  <!-- Popup Component (Pass closePopup function) -->
    <app-add-material *ngIf="isPopupVisible" [closePopup]="closePopup.bind(this)"></app-add-material>
  




 <div class="container-fluid" >
  <div class="row pt-3">
    <div class="col-sm-12">
      <div class="page-title-box">
        <!-- Button to Export Data to Excel -->

        <div class="card">
          <div class="card-header bg-primary text-center text-white">

            <!-- Back Button to Go to Initial Stock View (Only shown when a subcategory is displayed) -->
            <button class="button-7" role="button" *ngIf="showSubcategoriesForCategory !== null && !viewDetailsMode"  (click)="goBack()">Back</button>
            <span class="ml-3">TOTAL STOCK</span>
            <button  class="button-7" role="button" (click)="exportToExcel()">Export to Excel</button>

          </div>
          <div class="card-body">
            <table class="table table-bordered">
              <thead>
                <tr class="bg">
                  <!-- Initial Category/Subcategory Table -->
                  <th *ngIf="!viewDetailsMode">Code</th>
                  <th *ngIf="!viewDetailsMode">Description</th>
                  <th *ngIf="!viewDetailsMode">Input</th>
                  <th *ngIf="!viewDetailsMode">Output</th>
                  <th *ngIf="!viewDetailsMode">Balance</th>
                  <th *ngIf="!viewDetailsMode">Action</th>
  
                  <!-- Detailed Table Header for Subcategory -->
                  <th *ngIf="viewDetailsMode">Date</th>
                  <th *ngIf="viewDetailsMode">Group</th>
                  <th *ngIf="viewDetailsMode">Material</th>
                  <th *ngIf="viewDetailsMode">Description</th>
                  <th *ngIf="viewDetailsMode">Qty Supplied</th>
                  <th *ngIf="viewDetailsMode">Qty Accepted</th>
                  <th *ngIf="viewDetailsMode">Balance</th>
                  <th *ngIf="viewDetailsMode">Action</th>
                </tr>
              </thead>
              <tbody>
                <!-- Show categories initially -->
                <ng-container *ngIf="showSubcategoriesForCategory === null">
                  <tr *ngFor="let category of categories">
                    <td>{{ codePrefix }}</td>
                    <td>{{ descriptionPrefix }} -> {{ category }}</td>
                    <td>{{ calculateTotalInput(category) }}</td>
                    <td>{{ calculateTotalOutput(category) }}</td>
                    <td>{{ calculateTotalBalance(category) }}</td>
                    <td>
                      <button class="button-7" role="button" (click)="onNextButtonClick(category)">Next</button>
                    </td>
                  </tr>
                </ng-container>
  
                <!-- Show subcategories once the "Next" button is clicked -->
                <ng-container *ngIf="showSubcategoriesForCategory !== null && !viewDetailsMode">
                  <tr *ngFor="let subcategory of subcategories; let i = index">
                    <td>{{ '300' + (i + 1) }}</td>
                    <td>{{ showSubcategoriesForCategory }} -> {{ subcategory }}</td>
                    <td>{{ calculateTotalInput(subcategory) }}</td>
                    <td>{{ calculateTotalOutput(subcategory) }}</td>
                    <td>{{ calculateTotalBalance(subcategory) }}</td>
                    <td>
                      <button class="button-7" role="button" (click)="viewDetails(subcategory)">View Details</button>
                    </td>
                  </tr>
                </ng-container>
  
                <!-- Show detailed information once "View Details" is clicked -->
                <ng-container *ngIf="viewDetailsMode">
                  <tr *ngFor="let detail of detailsForSubcategory">
                    <td>{{ detail.receivedDate | date }}</td>
                    <td>{{ detail.supplier }}</td>
                    <td>{{ detail.materialTypeGrade }}</td>
                    <td>{{ detail.materialDescription }}</td>
                    <td>{{ detail.qty - detail.qty }}</td>
                    <td>{{ detail.qty }}</td>
                    <td>{{ detail.qty}}</td> <!-- Calculate balance -->
                    <td>
                      <button class="button-7" role="button" (click)="onBackFromDetails()">Back</button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
   
  </div>
  



  
  
  
  
  
  
  
  